import { FC, ReactElement } from 'react';

interface Props {
    title: string;
    Content: ReactElement;
    Footer?: ReactElement;
}

const AdditionalInfo: FC<Props> = ({ title, Content, Footer }) => (
    <div className="flex flex-col">
        <span className="h-8 px-4 font-sf text-13 font-medium flex items-center leading-[15.87px]">{title}</span>
        <div className="p-2">{Content}</div>
        <div className="px-2 py-1 border-t border-sf-gray-100">{Footer}</div>
    </div>
);

export default AdditionalInfo;
